import { render, staticRenderFns } from "./CompanyQuestionTwo.vue?vue&type=template&id=0ab09904&scoped=true&"
import script from "./CompanyQuestionTwo.vue?vue&type=script&lang=js&"
export * from "./CompanyQuestionTwo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyQuestionTwo.vue?vue&type=style&index=0&id=0ab09904&prod&scoped=true&lang=css&"
import style1 from "./CompanyQuestionTwo.vue?vue&type=style&index=1&id=0ab09904&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab09904",
  null
  
)

export default component.exports